<template>
  <v-dialog v-model="dialog" persistent width="300">
    <v-card dark>
      <v-card-text>
        {{ text }}
        <v-progress-linear :indeterminate="indeterminate" v-model="value" color="white" class="mb-0"></v-progress-linear>
        <!-- <v-progress-circular style="margin-left: 50px;" indeterminate color="primary"></v-progress-circular> -->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import Axios from 'axios';

  export default {
    name: 'ProgressDialog',
    data() {
      let self = this;
      return {
        dialog: false,
        text: 'Loading, please wait...',
        dialogColor: 'primary',
        value: 0,
        indeterminate: false
      }
    },
    methods: {
      show(indeterminate = false) {
        this.dialog = true;
        this.indeterminate = indeterminate;
      },
      setCurrentValue(value) {
        this.value = value;
      },
      setText(text) {
        this.text = text;
      },
      hide() {
        this.dialog = false;
      },
    }
  }
</script>